<template>
  <div class="footer-container">
    <span>Shoutout to Brad Traversy</span>
    <a href="https://github.com/bananaborane">
      <i class="fab fa-github-square fa-2x"></i>
    </a>
    <a href="https://webdevlouie.com">
      <i class="fas fa-address-card fa-2x"></i>
    </a>
    <span>Thanks & Much Love</span>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {}
};
</script>

<style scoped>
.footer-container {
  width: 100%;
  background-color: rgb(27, 27, 27);
  color: rgb(132, 132, 132);
  display: flex;
  justify-content: center;
  padding: 30px 0px;
}

.footer-container span {
  color: rgb(27, 27, 27);
  width: 20rem;
  text-align: center;
}
.footer-container a {
  margin: 0rem 1.2rem;
  transition:all 0.3s ease;
}

.footer-container a i {
  transition:all 0.12s ease;
}

.footer-container a i {
  color: rgb(132, 132, 132)
}



.footer-container a i:hover {
	transition: all 0.95s;
	transform: rotateY(360deg);
  color: white;
}
</style>